const MANIFEST = {
    version: 0.42,
    author: 'Konrad Abe',
    studio: 'All Bits Equal',
    name: 'Clash of Emoji',
}

export default MANIFEST
